// /store/modules/leadTracker.js
import apiClient from "../../plugins/axios";

export default {
  namespaced: true,
  state: () => ({
    loading: false,
    trackedLeads: [],
    trackedLeadsOfSource: [],
  }),
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setTrackedLeads(state, trackedLeads) {
      state.trackedLeads = trackedLeads;
    },
    setTrackedLeadsOfSource(state, trackedLeadsOfSource) {
      state.trackedLeadsOfSource = trackedLeadsOfSource;
    },
  },
  actions: {
    async getLastRawLeads({ commit }) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get("/getters/getLastRawLeads");
        commit("setTrackedLeads", response.data);
      } catch (error) {
        console.error("Failed to get tracked leads:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async getLastRawLeadsOfSource({ commit }, { sortBySource }) {
      commit("setLoading", true);
      if (!sortBySource) {
        console.error("No source specified");
        commit("setLoading", false);
        return;
      }
      try {
        const response = await apiClient.get(
          "/getters/getLastRawLeadsOfSource",
          {
            params: { sortBySource },
          }
        );
        commit("setTrackedLeadsOfSource", response.data);
      } catch (error) {
        console.error("Failed to get tracked leads of source:", error);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
